module.exports = __webpack_public_path__ + "static/media/arrow-purple-up.1a82947c.svg";